export const continueBtnDataSet = { cy: 'tell-your-story-continue-btn' };
export const editIntroButtonDataSet = { cy: 'edit-button-intro' };
export const editIntroButtonDisabledDataSet = { cy: 'edit-button-intro-disabled' };
export const confirmDeleteButtonDataSet = { cy: 'confirm-delete-button-intro' };

export const skipIntroButtonDataSet = { cy: 'skip-intro-button' };

export const tellYourStoryDropzoneDataset = { cy: 'tell-your-story-dropzone' };
